<!-- 父母英语水平差，还可以亲子阅读吗？ -->
<template>
  <div>
    <h2 style="text-align:center">父母英语水平差，还可以亲子阅读吗？</h2>
    <p style="text-align:center;color:gray;font-size:10pt"><span style="color:blue">51Talk青少服务号</span></p>
    <img data-type="gif" data-src="../../../static/images/51talk_small.gif" data-copyright="0" style="width: auto !important; height: auto !important; visibility: visible !important;"
      class=" __bg_gif" data-ratio="0.344" data-w="750" src="../../../static/images/51talk.gif" data-order="0" data-fail="0">
    <!-- <p style="text-align:center; color: red;">&nbsp;*****</p> -->
  
    <p><strong >请注意, 本文信息量4000字, 阅读时长约15-20分钟</strong></p>
    <p>
      读完本文，您可以刷新以下几点认知：
      <ol>
        <li>亲子阅读的重要性和必然性，几乎<strong>70%的书籍都是需要家长和孩子一起来完成的</strong></li>
        <li>一个月的阅读习惯对小孩的口语能力的影响，可以<strong>持续9个月之久</strong></li>
        <li>亲子阅读中，孩子解析一句话首先是辨别音素其次是语调，而亲子阅读更多锻炼的是孩子听的能力，而不是给孩子读的能力</li>
        <li>如何给孩子选择适当的亲子阅读的绘本</li>
        <li>亲子阅读到底应该怎么读，父母阅读方式的不同，会带来完全不同的效果</strong></li>
      </ol>
      <span style="color:#3f3f3f;font-size: 12px;color: #888888;">---------------------------------------------------------------------</span>
    </p>
  
    <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(0, 180, 238)">
      <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
        <section style="padding: 10px;box-sizing: border-box;">
          <section style="width: 100%;" data-width="100%">
            <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
              <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
              <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
                <p class="" data-brushtype="text" data-original-title="" title=""></p>
              </section>
              <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
            </section>
          </section>
        </section>
      </section>
    </section>
  
    <h3 style="text-align:center">亲子阅读究竟有多重要？</h3>
    <p>
      有学者认为语言能力是人类本能，但阅读能力不是这样，儿童没有自主阅读的能力，这也是为何亲子阅读很重要的原因，儿童在阅读理解中需要他人的引导。美国Renaissance公司通过调研了接近30万学龄前儿童，统计数据显示每人平均阅读22本书，而所有人阅读的书籍中，<span>46%的书籍为“被动阅读”，由别人阅读给孩子听；21%的书籍，是共读，33%的书籍，是自主阅读</span>。由此可以看到学龄前几乎70%的书籍都是需要家长和孩子一起来完成的。绘本对儿童成长的帮助建立在亲子绘本阅读的基础上，尤其是早期绘本阅读，也就是早期阅读启蒙。而大部分阅读障碍者并不是阅读能力的问题，而是听力辨识上存在问题。
    </p>
    <p>众多研究同样表明，有过亲子阅读的孩子长大后的认知能力和语言表达能力都要强于没有亲子阅读的孩子。而亲子关系对语言习得也起着较为重要的作用。美国的国家教育统计中心发现，美国45%的父母每天都会给小孩阅读，家中女宝宝的亲子阅读比例比男宝宝高，头胎比二胎高，可能因为"头胎当宝养，二胎当猪养”的原因吧。而北美3-5岁的孩子的家庭中，81%的家庭每周都会进行亲子阅读活动（2000年数据）,不阅读的一般是低收入家庭，他们文化水平不高或者工作太忙没有时间陪伴孩子，这个实验的研究者研究了低收入家庭的亲子阅读活动对小孩的影响发现和已有的研究结果达成一致，所谓的你给孩子了怎么的输入，孩子就有了怎样的输出。而这个输入不仅仅是父母的学识、资本，更有倾注进去的时间成本。寒门再难出学子或“阶级正在固化”讲的也是类似的道理。从布鲁姆体系来看，孩子的成长主要可以分为认知能力、情感能力和动作发展能力，这几部分中认知的提升最重要的就是通过阅读的输入或者听的输入，而亲子阅读相当于给孩子站在了父母肩膀的机会，给了读和听的输入机会，因此对培养孩子的诸多技能都有好处，比如：
      <ul>
        <li>词汇量的发展(Bus et al.,1995;DeBaryshe,1993;Snow & Goldfield,1983)</li>
        <li>对虚拟世界的理解，对图片和文字作为符号的理解(Snow & Ninio，1986)</li>
        <li>对故事结构和套路的理解(Cochran-Smith,1984)</li>
        <li>情感：萌发阅读的积极态度(Lonigan,1994; Taylor & Stricklan,1986)</li>
        <li>动作：一岁2个月的小孩对词汇理解和符号手势的理解(Bayley,1993)</li>
        <li>语言发展：2岁的小孩词汇产出，产出句子长度和认知能力都是相关的（Lyytinenet al.,1998)</li>
      </ul>
    </p>
    <p>
  
      来自美国学者Wilt和Rankin各自的研究，获得的数据是一致的：<span>在个体清醒的时候，平均有百分之七十以上的时段从事语言交流；这其中，听说读写四种形式的交流各占45%，30%，16%和9%</span>，75%+都是在语言交流，而亲子阅读更多锻炼的是孩子听的能力，而不是给孩子读的能力。而孩子需要听懂一句话也需要几个层次：
      <ul>
        <li>第一个层次，清晰地辨别出音素（最小的语音单位，如单辅音单元音）、音素组合，音节等等。</li>
        <li>第二个层次，在基本语音加工的基础上，能够胜任单词切分，以及跨音节跨单词的语调模式（prosodic ) </li>
        <li>第三个层次，检索或激活或推测单词及词组的含义</li>
        <li>第四个层次，能够根据句法规则将单词与词组组合成更大的意义单位（句子的含义）</li>
        <li>第五，至少从第三个层次开始，都要同时调动背景知识（存储在大脑中噢乖的长期记忆系统和环境线索（外界的各种状况），最终把语音流的意义整合起来</li>
      </ul>
    </p>
  
    <p>但最重要的第一个层次和第二个层次，就是音素的识别，Kuhl教授研究发现：年龄较大的学龄前的儿童，仅仅电视节目学习母语和外语的效果也是很有限的，他们可以学到一些词汇，但是对音素的感知和文法掌握效果不大，因此一定需要交互。而如果父母完全没办法说英文的情况下，也尽量可以学习指认，即动词TPR和名词指着说，这部分对家长的能力的要求不高。</p>
  
    <p>学习第二语言，希望达到母语水平，是经验期待性学习（Experience－expectant Learning）。实现这种学习需要两个基本条件：一个是神经系统的发育为这种学习提供了可能实现的机会,隐含了敏感期的思想；另一方面，能为幼儿提供合适的环境刺激，包括社会情绪的环境。这种环境的刺激在合适的时机里出现，才会实现这种学习过程，达到预想的目的。<span>有关语言学习的神经回路不是一个孤立的回路，而是涉及感知、认知、情感、动作等广泛的神经回路，因此语言的学习必须需要情感、动作、认知等多方面的配合</span>。</p>
  
  
    <!-- <p style="text-align:center; color: red;">&nbsp;*****</p> -->
    <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
      <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
        <section style="padding: 10px;box-sizing: border-box;">
          <section style="width: 100%;" data-width="100%">
            <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
              <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
              <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
                <p class="" data-brushtype="text" data-original-title="" title="">1</p>
              </section>
              <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
            </section>
          </section>
        </section>
      </section>
    </section>
    <h3 style="text-align:center">如何选择亲子阅读的绘本</h3>
  
    <p>
      在现代社会，电视已成为幼儿获取信息的重要途径，很多幼儿都喜欢看动画片，所以，根据幼儿熟悉的电视节目改编的图书也颇受幼儿的欢迎，因为有了之前的视听经验，转换成图书阅读，比较容易引起幼儿的心理共鸣，幼儿能较快、较好地理解故事情节。但家长为孩子选择图书，最主要的还是以孩子的兴趣特点来选择，这样孩子才能在无压力的环境中重复，重复多了才能慢慢内化为学习能力，对于不同阶段孩子的特点家长可以这样选择书籍：
      <ul>
        <li><strong>4个月~1岁</strong>：以视觉刺激的绘本为主</li>
        <li><strong>1岁~2岁</strong>：了解实践各种基本生活习惯+基本认知的培养，比如</li>
        <li><strong>2岁+</strong>：以激发孩子的兴趣为主+建立各种规则+培养生活能力及学习习惯，比如托马斯小火车，贝贝熊系列</li>
      </ul>
    </p>
    <p>
      1岁左右是宝宝色彩和视觉感知的重要阶段，这个阶段的孩子对陌生的事务充满着好奇心。父母的侧重于为孩子选择丰富的色彩的绘本，引导宝宝指称图片和相应的绘本人物。阅读绘本的选择倾向于图片比较大，故事内容简单的绘本。与可以选择一些带有“洞洞”的绘本让宝宝去抠完，加强孩子手指的灵活度和动手的能力。此时的宝宝对故事情节不那么感兴趣，父母可以引导宝宝自己去翻书，妈妈也可以大声朗读怀孕之前喜欢的读物，给孩子每次讲绘本的时间不要过长
      <img data-w="" data-ratio="0.5625" title="绘本洞洞书" src="../../../static/images/picture_book.jpg">
    </p>
    <p>
      1到2岁的小朋友可以选择和生活周遭有关的绘本，故事情节比较丰富。家长可以用戏剧化的语言将宝宝代入剧情。例如家长可以模仿猴子走路或者模仿蜜蜂的声音等。家长可以选择和宝宝生活密切相关的环节和起床、自己穿衣服、吃饭、自己收拾玩具的绘本
    </p>
    <p>
      2岁到3岁的小孩绘本选择更加具有想象力、内容多元的绘本内容。家长可以去和孩子交流彼此对于绘本中人物的看法。家长也要耐心的回答宝宝对于绘本的问题和困惑。父母要鼓励宝宝多说话，多点评，这样对宝宝的语言发展有好处
    </p>
    <p>
      3岁以上的孩子可以慢慢选择一些分级读物，比如海尔曼GK、牛津阅读数ORT stage1-4进行知识面的扩充，当然关注了我们的整个学习计划，这些我们都会根据孩子在不同年龄阶段以及兴趣点来进行推送，家长们需要做的就是配合我们反馈孩子的学习进展，助力孩子的成长。
    </p>
  
    <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
      <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
        <section style="padding: 10px;box-sizing: border-box;">
          <section style="width: 100%;" data-width="100%">
            <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
              <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
              <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
                <p class="" data-brushtype="text" data-original-title="" title="">1</p>
              </section>
              <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
            </section>
          </section>
        </section>
      </section>
    </section>
    <h3 style="text-align:center">亲子阅读究竟应该怎么读</h3>
    <p>
      Whitehurst教授在1988年做了一个关于父母绘本阅读的实验。该实验设计了一套亲子阅读的方式，实验组的父母使用教授设计的亲子阅读方式，这种阅读方式包括：父母在阅读过程中提出的对开放性问题、功能性问题（function/attribute questions）和扩展性问题，在实验组，父母提出这三种类型的问题也以不同的比率搭配出现；而控制组的父母随意阅读，就是父母自己本来的风格是怎样的就按照怎样的阅读方式。结果显示实验组的小孩在语言表达能力（expressive language ability）上显著高于控制组的小孩。同时，实验组的小孩有更长的平均句子长度MLU（mean
      lenght of utterance）【常用的评估口语能力的标准】，短语出现的频率更高，单个词语出现的频率更低。对同样的这两组家庭，教授的又有长达9个月的继续追踪调查，发现实验组和控制组的小孩之间依然存在差异.</p>
    <p>
      这个实验说明两点：
      <ul>
        <li><strong>在亲子阅读过程中，父母阅读方式的不同，会带来不同的效果；</strong></li>
        <li><strong> 一个月的阅读习惯对小孩的口语能力的影响，可以持续9个月之久</strong>，所以，我们要相信父母在亲子阅读中的力量，要相信：父母采用不同的阅读方式，会带来不同的效果。</li>
      </ul>
    </p>
  
    <p>Kathryn教授的研究也证明了对24个月大的宝宝的阅读频率的增加会影响宝宝在30个月时候的口语产出能力，但是这个增加的阅读频率一定是要建立在父母在阅读过程中提出了更好的问题，也就是说，如果只是普通随意的阅读，这个30个月时候体现出的优势并不成立，只有在阅读过程中有不同的提问方式才能成立.那么父母在阅读绘本时如何引导小孩，如何科学地讲故事呢？周兢教授2016年的新书中提出了一个CROWD原则(周兢：《零岁起步:0-3岁儿童早期阅读与指导》)：
      <ul>
        <li><strong>Completion，补充型提示</strong>：让儿童将句子补充完整。例如当书中有押韵或重复性短语时常常采用这样的提示的方式。比如，brown bear brown bear......？【0-2岁更适合】</li>
        <li><strong>Recall，回忆型提示</strong>：对儿童读过的内容进行提问，帮助儿童梳理故事情节。【0-2岁更适合】</li>
        <li><strong>Open-ended,开放型提示</strong>:开放型提示将重点放在书中的图画上，对画面信息丰富的绘本来说，这是最佳提问方式。【2-3岁更适合】</li>
        <li><strong>Wh-question,特殊性提示</strong>: 主要功能是教会儿童一些新的词汇。【2-3岁更适合】</li>
        <li><strong>Distancing,间距型提示</strong>: 要求儿童将书中内容与儿童的实际经验联系起来，为儿童搭建起一座连接书本与现实世界的桥梁，有助于提高儿童语言表达的能力。（少提知识性的问题，多问经验性的问题,后面会有例子）【2-3岁更适合】</li>
      </ul>
    </p>
    <p>
      在美国的<a href="http://www.reachoutandread.org/">Reach out and read</a>的官网,也给出了亲子阅读的建议:
      <ul>
        <li>1岁：允许小孩在阅读过程中到处爬，指读图，让小孩明白书中的的标志和符号对应生活中的实物；而孩子可能表现出喜欢在睡前阅读，且反复阅读一本书，对书开始表现出喜好的倾向，更喜欢有食物、交通工具、动物和带有小朋友的书，喜欢绘本类</li>
        <li>2岁: 阅读生活中常见的物品标志，让小孩子自己选择喜欢的绘本；孩子开始指认图片，开始会翻书、抢答，喜欢听一个故事，喜欢一些关于动物或者声音的书籍</li>
        <li>3岁+： 让小孩坐在怀中读书，问关于故事的问题，让小孩自己讲故事，每周去一次绘本馆或者图书馆；孩子表现为喜欢故事性更完整的绘本，慢慢可以接受没有文字的绘本，开始对数字和字母的书敏感，喜欢跟家庭、友情和学校幼儿园相关书籍，喜欢在睡前阅读</li>
      </ul>
    </p>
  
    <p>
      而家长孩子3岁以上也可以跟孩子一起进行精读绘本，比如：
      <ul>
        <li><strong>角色扮演</strong>：如果孩子比较喜欢的绘本，在重复讲的时候可以尝试一些新的方法，只要家长愿意头投入其中，效果是很好的，比较适合角色较少对白较多的绘本，比如加入狐狸和兔子互道晚安或别让各自开巴士，这一类可以让小孩融入其中学习体验不同角色下的情感，有助于建立小孩换位思考和共情的能力</li>
        <li><strong>绘画创作</strong>：比如针对一些学习颜色或者动物的时候，自行绘画一本动画书，给不同的动物涂色等</li>
        <li><strong>故事再创作</strong>：鼓励小孩子对绘本进行在创作，比如修改不喜欢的情节，续写故事的后续，这样的话孩子也能充分的参与进来且有了自己的师姐，这个世界对于儿童而言非常重要</li>
      </ul>
      这些都可以关注我们的学习计划，后期都会根据具体的绘本来进行推送绘本究竟应该怎么玩。如果你觉得本文不错的话，也可以转给身边的宝爸宝妈们哟~~
    </p>
  
    <p><span>&nbsp;</span></p>
    <p style="text-indent: 2px;">本文作者<strong>@Statoor </strong></p>
    <span style="color:#3f3f3f;font-size: 12px;color: #888888;">-------------------------------------------------</span>
    <p style="color:gray;text-indent: 2pt;">Statoor，51Talk算法工程师</p>
    <br>
  </div>
  </template>
  
  <script>
  export default {
    name: 'ParentRead2',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    body {
      color: #555;
      margin-left: auto;
      margin-right: auto;
      line-height: 20px;
      font-size: 14px;
      font-family: 微软雅黑, sans-serif;
      text-indent: 28px;
      line-height: 1.6
    }
  
    h2 {font-size: 16pt}
  
    li {
      text-indent: 2px;
    }
  
    blockquote {
      text-indent: 1px;
      color: silver;
    }
  
    strong {
      color: rgb(0, 180, 238);
    }
  
    span {
      color: rgb(0, 180, 238);
    }
  
    @media screen and (max-width: 3600px) {
      body {
        width: 550px;
      }
    }
  
    img {
      max-width: 100%;
    }
  
    @media screen and (max-width: 500px) {
      body {
        width: 98%;
      }
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/parentread/PictureBook2.vue